export const validSpreadsheetTypes = ['xls', 'xlsx'];

export const validSpreadsheetMimeTypes = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
